import { Box } from '@material-ui/core';
import { useEffect } from 'react';

import { useSetLenderRequestId } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/hooks/useSetLenderRequestId';
import { UseDialogProps } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/LoanApplicationActionDialog';
import {
  SetLenderRequestIdSchema,
  SetLenderRequestIdType,
} from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/schemas/SetLenderRequestIdSchema';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface SetLenderRequestIdActionDialogProps {
  loanId: string;
  loanApplicationId: string;
  setLoanApplicationAction: (e) => void;
  useDialogProps: UseDialogProps;
}

export const SetLenderRequestIdActionDialog = ({
  loanId,
  loanApplicationId,
  setLoanApplicationAction,
  useDialogProps,
}: SetLenderRequestIdActionDialogProps) => {
  const { loading, setLenderRequestId } = useSetLenderRequestId({
    loanId,
    loanApplicationId,
  });

  const { opened, setOpened, toggleDialog } = useDialogProps;

  useEffect(() => {
    return () => {
      () => setLoanApplicationAction(undefined);
    };
  }, []);

  const onSubmit = async (formValues: SetLenderRequestIdType) => {
    await setLenderRequestId({
      id: loanApplicationId,
      lenderRequestId: formValues.lenderRequestId,
      setOpened,
    });
    toggleDialog();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CHANGE_LENDER_APPROVAL_STATUS'}
      saveButtonTextId={'MODIFY'}
      isLoading={loading}
      onSubmitForm={onSubmit}
      formSchema={SetLenderRequestIdSchema}
    >
      <>
        <Font variant="body2" color="textSecondary">
          <Text tId={'CHANGE_LENDER_APPROVAL_STATUS_DESCRIPTION'} />
        </Font>
        <Box pt={3}>
          <TextFormField label={'LENDER_REQUEST_ID'} name={'lenderRequestId'} />
        </Box>
      </>
    </EditDialogWrapper>
  );
};
